var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_contact_sync"
  }, [_c('h1', [_vm._v($t("d7cdtl5", "通讯录同步"))]), _c('p', [_vm._v($t("4v53zwf", "将企业微信用户同步到iWork"))]), _c('Button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.syncLoading,
      "disabled": _vm.syncLoading
    },
    on: {
      "click": _vm.syncContacts
    }
  }, [_vm._v(` ${$t("ccxa044", "开始同步")} `)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };